import React from 'react'
import {
  getMatchFromGeneralDictionary,
  formMasterTypesInnerData,
  getFormElementType,
  hiddenFormFields,
  readOnlyFields,
  requiredFields,
  FormElementNames,
  formGetGroupElementValues,
  formGroupingLogic,
  getFormValidation,
  masterTypesInnerDataForTableRendering
} from '../lib/formElementMappings'

import { formElementInterface, keyValue, keyValueObject, selectBoxOptionsInterface } from '../lib/types'
import { getFormFieldStyle } from './formComponent.support'
import { Box, Heading, Flex, HStack } from '@chakra-ui/react'
import DataTable from 'react-data-table-component'
import { customStyles } from './dataTable'

interface allTypesDataMappingInterface {
  [key: string]: {
    innerKey: string
    allTypesKey: string
  }
}
const allTypesDataMapping: allTypesDataMappingInterface = {
  element_type: { innerKey: 'element_type', allTypesKey: 'elementTypes' },
  element_orientation: {
    innerKey: 'orientation',
    allTypesKey: 'elementOrientations'
  },
  element_material_conf: {
    innerKey: 'material_conf',
    allTypesKey: 'elementMaterialConf'
  },
  element_material: {
    innerKey: 'material_name',
    allTypesKey: 'elementMaterials'
  },
  element_mod: {
    innerKey: 'element_mod_details',
    allTypesKey: 'elementMods'
  },
  element_mod_type: {
    innerKey: 'element_mod_type',
    allTypesKey: 'elementModTypes'
  },
  thickness_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  dim_1_type: { innerKey: 'dim_type', allTypesKey: 'dimensionTypes' },
  dim_2_type: { innerKey: 'dim_type', allTypesKey: 'dimensionTypes' },
  dim_3_type: { innerKey: 'dim_type', allTypesKey: 'dimensionTypes' },
  dim_4_type: { innerKey: 'dim_type', allTypesKey: 'dimensionTypes' },
  dim_1_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  dim_2_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  dim_3_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  dim_4_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  base_diameter_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  inside_diameter_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  nominal_size_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  height_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  width_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  size_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  service_add_unit: { innerKey: 'unit_name', allTypesKey: 'units' },
  product_manufacturer: {
    innerKey: 'manufacturer_name',
    allTypesKey: 'productManufacturers'
  },
  product_brand: {
    innerKey: 'brand_name',
    allTypesKey: 'productBrands'
  },
  fixing_tested: {
    innerKey: 'fixing_test_list',
    allTypesKey: 'fixing_tested'
  },
  application: {
    innerKey: 'application_name',
    allTypesKey: 'applications'
  },
  product_installation_type: {
    innerKey: 'installation_type',
    allTypesKey: 'productInstallationTypes'
  },
  installation_type: {
    innerKey: 'installation_type',
    allTypesKey: 'productInstallationTypes'
  },
  product_category: {
    innerKey: 'category_name',
    allTypesKey: 'productCategories'
  },
  product_sub_category: {
    innerKey: 'product_sub_category_name',
    allTypesKey: 'productSubCategories'
  },
  is_active: { innerKey: 'value', allTypesKey: 'is_active' },
  is_current: { innerKey: 'value', allTypesKey: 'is_current' },
  fixing_required: { innerKey: 'value', allTypesKey: 'fixing_required' },
  fire_rated: { innerKey: 'value', allTypesKey: 'fire_rated' },
  is_lagging: { innerKey: 'value', allTypesKey: 'is_lagging' },
  is_email_verified: { innerKey: 'value', allTypesKey: 'is_email_verified' },
  display_status: { innerKey: 'value', allTypesKey: 'display_status' },
  display: { innerKey: 'value', allTypesKey: 'display' },
  build_sheet: { innerKey: 'value', allTypesKey: 'build_sheet' },
  report_type: { innerKey: 'report_type', allTypesKey: 'reportTypes' },
  doc_version_desc: { innerKey: 'version_desc', allTypesKey: 'documentVersions' },
  report_facility: {
    innerKey: 'facility',
    allTypesKey: 'reportFacilities'
  },
  report_status: { innerKey: 'status', allTypesKey: 'reportStatuses' },
  report_publishing: { innerKey: 'release', allTypesKey: 'reportPublishings' },
  service_type: { innerKey: 'service_type', allTypesKey: 'serviceTypes' },
  service_category: {
    innerKey: 'category_name',
    allTypesKey: 'serviceCategories'
  },
  service_sub_category: {
    innerKey: 'service_sub_cat_name',
    allTypesKey: 'serviceSubCategories'
  },
  service_manufacturer: {
    innerKey: 'service_manufacturer',
    allTypesKey: 'serviceManufacturers'
  },
  service_brand: {
    innerKey: 'service_brand',
    allTypesKey: 'serviceBrands'
  },
  service_material: {
    innerKey: 'service_material',
    allTypesKey: 'serviceMaterials'
  },
  service_standard: {
    innerKey: 'service_std_name',
    allTypesKey: 'serviceStandards'
  },
  service_add_manufacturer: {
    innerKey: 'service_add_manufacturer',
    allTypesKey: 'serviceAddManufacturers'
  },
  service_add_brand: {
    innerKey: 'service_add_brand',
    allTypesKey: 'serviceAddBrands'
  },
  service_add_type: {
    innerKey: 'service_add_type',
    allTypesKey: 'serviceAddTypes'
  },
  service_add_group: {
    innerKey: 'service_add_group',
    allTypesKey: 'serviceAddGroups'
  },
  service_add: {
    innerKey: 'service_add',
    allTypesKey: 'serviceAdds'
  },
  report_standards: { innerKey: 'standard_name', allTypesKey: 'reportStandardList' },
  system_reports: { innerKey: 'inserted_on', allTypesKey: 'productTypes' },
  product_type: { innerKey: 'product_type', allTypesKey: 'productTypes' },

  product_instructions: {
    innerKey: 'instruction_code',
    allTypesKey: 'productInstructionList'
  },
  fixing_category: {
    innerKey: 'fixing_category',
    allTypesKey: 'fixingCategories'
  },
  fixing_group: {
    innerKey: 'fixing_group',
    allTypesKey: 'fixingGroups'
  },
  report: {
    innerKey: 'report_name',
    allTypesKey: 'reports'
  },
  system_note_type: {
    innerKey: 'system_note_type',
    allTypesKey: 'systemNoteTypes'
  },
  system_note: {
    innerKey: 'note_title',
    allTypesKey: 'systemNotes'
  },
  system: {
    innerKey: 'system_code',
    allTypesKey: 'systems'
  }
}
const getSelectOptions = (typeName: string, allTypes?: keyValueObject): selectBoxOptionsInterface[] => {
  const dataMap = allTypesDataMapping[typeName] ?? null

  if (dataMap === null || !allTypes) {
    return []
  }
  const rawGraphQLDataForTypes = allTypes[dataMap.allTypesKey] as keyValue[]
  switch (typeName) {
    case FormElementNames.is_active:
    case FormElementNames.display_status:
    case FormElementNames.fixing_required:
    case FormElementNames.is_current:
    case FormElementNames.fire_rated:
    case FormElementNames.is_lagging:
    case FormElementNames.is_email_verified:
    case FormElementNames.display:
    case FormElementNames.build_sheet:
      return [
        {
          id: 'true',
          value: 'true',
          display: 'Y'
        },
        {
          id: 'false',
          value: 'false',
          display: 'N'
        }
      ]

    default:
      return rawGraphQLDataForTypes?.reduce((reducer: selectBoxOptionsInterface[], item: keyValue) => {
        const reducedValue = [
          ...reducer,
          {
            id: typeName === 'thickness_unit' || typeName.includes('_unit') ? (item[dataMap.innerKey] as string) : (item.id as string),
            value: typeName === 'thickness_unit' || typeName.includes('_unit') ? (item[dataMap.innerKey] as string) : (item.id as string),
            display: item[dataMap.innerKey] as string
          }
        ]
        return reducedValue
      }, [])
  }
}

export const generateFormJSONForDataTables = (
  dataTableDataRow: keyValue,
  allTypes: keyValueObject | undefined,
  dataKey: string | null // null means masterDataTypes
): formElementInterface[] => {
  const keys = Object.keys(dataTableDataRow) ?? []
  const elementKeysJSON = keys.reduce((reducer: formElementInterface[], currentKey, index, array) => {
    if (hiddenFormFields.includes(currentKey as FormElementNames)) {
      return [...reducer]
    }

    const type = getFormElementType(currentKey as FormElementNames, dataKey)

    const name = `${currentKey}_name_${type}`
    const getValidation = getFormValidation(currentKey)
    // main JSON part
    const fieldData: formElementInterface = {
      type,
      name,
      originalKey: currentKey,
      title: `${getMatchFromGeneralDictionary(currentKey as FormElementNames) ?? currentKey}`,
      testId: `${currentKey}_testID`,
      placeHolder: readOnlyFields.includes(currentKey as FormElementNames) ? '' : ``,
      selectOptions: getSelectOptions(currentKey as FormElementNames, allTypes),
      groupValuesToDisplay: formGetGroupElementValues(currentKey),
      groupingLogic: formGroupingLogic(currentKey),
      value: formMasterTypesInnerData(currentKey, dataTableDataRow[currentKey] as string | keyValue, dataTableDataRow as string | keyValue, dataKey),
      validation: {
        required: requiredFields.includes(currentKey as FormElementNames),
        readOnly: readOnlyFields.includes(currentKey as FormElementNames),
        ...getValidation
      },
      holderProps: {
        flexGrow: '2',
        width: 'calc(50% - 32px)'
      },
      ...getFormFieldStyle(currentKey ?? 'text')
    }

    if (currentKey === '__typename') {
      return [...reducer]
    }
    return [...reducer, { ...fieldData }]
  }, [])
  const submit: formElementInterface = {
    type: 'submit',
    name: 'submitButton',
    originalKey: 'submitButton',
    title: 'Submit',
    testId: 'testSubmit',
    ...getFormFieldStyle('submit')
  }

  return [...elementKeysJSON, { ...submit }]
}

interface datatableColumnInterface {
  name: string
  selector: (row: keyValue) => string | JSX.Element
  sortable: boolean
  grow?: number
  allowOverflow?: boolean
  omit?: boolean
  wrap?: boolean
  minWidth?: string
}
const keysToOmit = ['__typename', 'id']

export const JSONToTable = ({ rawData, title }: { rawData: keyValueObject; title: string }): JSX.Element => {
  const filteredObjectKeys = Object.keys(rawData).filter(key => {
    const returnValue = masterTypesInnerDataForTableRendering(key, rawData[key] as string | keyValue)
    return typeof (returnValue === 'object') && typeof returnValue !== null
  })

  const filteredObjectValues = filteredObjectKeys.reduce((reducer: keyValueObject[], item) => {
    return [...reducer, { [item]: rawData[item] } as unknown as keyValueObject]
  }, [])

  const data = filteredObjectValues
  const localStorageCount = localStorage.getItem('JsonTableCount') ?? '0'
  localStorage.setItem('JsonTableCount', (parseInt(localStorageCount) + 1).toString())
  interface DataRow {
    name: string
    sortable: boolean
  }
  const getStringOrReactNode = (data: string | keyValue | number | null): string | JSX.Element => {
    if (data !== null && typeof data === 'object') {
      return (
        <>
          {Object.keys(data).map(key =>
            !keysToOmit.includes(key) ? (
              <HStack p="1" minWidth="180px" key={key} fontSize="11px" bg="blue.50" justifyContent={'flex-start'}>
                <Box fontWeight={'bold'}> {getMatchFromGeneralDictionary(key)}</Box>
                <Box>{data[key]}</Box>
              </HStack>
            ) : (
              ''
            )
          )}
        </>
      )
    }

    if (typeof data === 'boolean' && data) {
      return 'Y'
    }
    if (typeof data === 'boolean' && !data) {
      return 'N'
    }
    return data as string
  }
  const generateColumns = (inputData: keyValue): { columns: DataRow[] } => {
    const keys = Object.keys(inputData)

    const reducedValue = keys?.map(item => {
      const columnItem: datatableColumnInterface = {
        name: getMatchFromGeneralDictionary(item) as string,
        selector: inputData => getStringOrReactNode(inputData[item]),
        sortable: false,
        grow: 2,
        omit: keysToOmit.includes(item),
        wrap: true,
        minWidth: '190px'
      }
      return columnItem
    })

    return { columns: reducedValue ?? [] }
  }

  const keyValueToTable = (data: keyValueObject, title: string): JSX.Element => {
    const firstObjectKey = Object.keys(data)[0]

    const arrayValue = data[firstObjectKey] as keyValue[]
    const rand = localStorage.getItem('JsonTableCount') ?? 0

    return (
      <>
        {arrayValue !== undefined && arrayValue.length > 0 && (
          <Box
            width="fit-content"
            my="2"
            mx="1"
            p="4"
            borderWidth={'0px'}
            borderColor="grey.50"
            borderRadius="4px"
            shadow="lg"
            bgColor="#fff"
            key={`Box_${title}${rand}`}
          >
            <Heading size={'xs'} mb="4" key={`Heading_${title}${rand}`}>
              {title}
            </Heading>
            {Array.isArray(arrayValue) && <DataTable {...generateColumns(arrayValue[0])} data={arrayValue ?? []} customStyles={customStyles} />}
            {!Array.isArray(arrayValue) && <Box color="gray.600">{arrayValue}</Box>}
          </Box>
        )}
      </>
    )
  }

  const component = (
    <React.Fragment key={`mainTable_${title}`}>
      <Flex
        p="4"
        flexWrap={'wrap'}
        flexShrink="1"
        fontSize={'12px'}
        // bg="gray.50"

        width={['100%', '100%', '100%', '50%', '50%']}
      >
        {Array.isArray(data)
          ? data.map((item, index) => {
              const firstItem = Object.keys(item)[0]
              if (item !== null && firstItem !== null && item[firstItem] !== null && (item[firstItem] as keyValue[] | string[]).length > 0) {
                return keyValueToTable(item, getMatchFromGeneralDictionary(firstItem) as string)
              }
              return ''
            })
          : keyValueToTable(data, '')}
        {Array.isArray(data)}
      </Flex>
    </React.Fragment>
  )
  return component
}
